import styles from './result-grid.module.css';
import classNames from 'classnames';

interface Props {
  name: string;
  /** Secondary line under the name, e.g. "license · club". */
  meta?: string;
  /** Field label shown above the name in a standalone row that has no shared column header. */
  label?: string;
}

export function LifterCell({ name, meta, label }: Props) {
  return (
    <div className={classNames(styles.cell, styles.lifter)}>
      {label && <span className={styles.cellLabel}>{label}</span>}
      <span className={styles.lifterName}>{name}</span>
      {meta && <span className={styles.lifterMeta}>{meta}</span>}
    </div>
  );
}
